.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.label {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-secondary);
}

.hint {
  margin: 0;
  font-size: 0.8125rem;
  font-weight: 400;
  color: var(--text-muted);
}

.select,
.textarea {
  min-height: 48px;
  padding: 0 14px;
  background: var(--bg-elevated);
  border: 1px solid var(--border-primary);
  border-radius: 0;
  color: var(--text-primary);
  transition: border-color var(--dur-fast) var(--ease-out);
}

.textarea {
  min-height: 120px;
  padding: 12px 14px;
  resize: vertical;
  line-height: 1.5;
}

.select:hover,
.textarea:hover {
  border-color: var(--text-muted);
}

.select:focus-visible,
.textarea:focus-visible {
  border-color: var(--accent);
  outline-offset: 0;
}

.check {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.box {
  appearance: none;
  flex: none;
  width: 20px;
  height: 20px;
  margin: 2px 0 0;
  background: var(--bg-elevated);
  border: 1px solid var(--border-primary);
  border-radius: 0;
  cursor: pointer;
  display: grid;
  place-items: center;
}

.box:checked {
  background: var(--accent);
  border-color: var(--accent);
}

.box:checked::after {
  content: '';
  width: 10px;
  height: 5px;
  border-left: 2px solid var(--accent-foreground);
  border-bottom: 2px solid var(--accent-foreground);
  transform: translateY(-1px) rotate(-45deg);
}

.checkLabel {
  display: flex;
  flex-direction: column;
  gap: 2px;
  cursor: pointer;
}

.notice {
  padding: 12px 14px;
  border: 1px solid var(--border-primary);
  font-size: 0.9375rem;
  line-height: 1.5;
}

.info {
  color: var(--text-secondary);
}

.error {
  border-color: var(--status-busy);
}

.success {
  border-color: var(--status-ok);
}

.pageHeader {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 32px;
}

.pageTitle {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 800;
  font-stretch: 116%;
  letter-spacing: -0.035em;
  line-height: 1;
}

.pageActions {
  display: flex;
  gap: 12px;
}

.empty {
  padding: 32px 0;
  color: var(--text-muted);
}

.tag {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 0 8px;
  border: 1px solid var(--border-primary);
  font-size: 0.8125rem;
  color: var(--text-secondary);
  white-space: nowrap;
}

.tag_ok {
  border-color: var(--status-ok);
  color: var(--text-primary);
}

.tag_warn {
  border-color: var(--accent);
  color: var(--text-primary);
}

.tag_busy {
  border-color: var(--status-busy);
  color: var(--text-primary);
}
